import React from 'react';
import TaskCounter from '../components/TaskCounter';
import TaskDataFetcher from '../components/TaskDataFetcher';

const TaskCountPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Task Collection Overview
          </h1>
          <p className="text-gray-600">
            View the total number of tasks in your collection
          </p>
        </div>
        
        <div className="grid gap-6">
          <div className="error-boundary-wrapper">
            <TaskCounter />
          </div>
          
          <div className="error-boundary-wrapper">
            <TaskDataFetcher />
          </div>
          
          <div className="p-6 bg-white rounded-lg border border-gray-200 shadow-sm">
            <h3 className="text-lg font-semibold text-gray-800 mb-4">
              Collection Information
            </h3>
            <div className="space-y-3 text-sm text-gray-600">
              <div>
                <span className="font-medium">Collection Name:</span> tasks
              </div>
              <div>
                <span className="font-medium">Type:</span> Enhanced task management and tracking system for metrics
              </div>
              <div>
                <span className="font-medium">Status:</span> Active collection with lifecycle hooks
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaskCountPage;
